import { forwardRef } from 'react';
import NextButtonWrapper from '../views-components/NextButtonWrapper';
import { Data } from 'signup-constants/signupData/Data';
import { SignupDataInput } from './SignupDataInput';
import { useSignupData } from './useSignupData';
import { Step } from 'signup-constants/Step';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
import { useExperiment, TrackWhen } from '../experiments/useExperiment';
import { useCurrentStep } from '../hooks/useCurrentStep';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Spacer } from 'foundations-components/components/Spacer';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SignupDataInputForm = /*#__PURE__*/forwardRef(({
  button,
  dataKey,
  disabled,
  nextButtonEnabled,
  customValidationError,
  shouldShowPlaceholder,
  renderExtraContent = () => null,
  renderExtraIcons,
  submit,
  type,
  inputMode,
  buttonProps,
  help,
  shouldTrimData = false,
  inputHeight = '',
  labelOverride
}, ref) => {
  const {
    currentStep
  } = useCurrentStep();
  const {
    isAssignedToSpecificVariant: isAssignedToACQ173Variant
  } = useExperiment(ExperimentKeys.ACQ0173, TrackWhen.enrolled);
  const isAssignedToACQ173VariantA = isAssignedToACQ173Variant(ExperimentParameterGroup.Variant_A);
  const isAssignedToACQ173VariantC = isAssignedToACQ173Variant(ExperimentParameterGroup.Variant_C);
  const acq173UpdateEmailInputForm = (isAssignedToACQ173VariantA || isAssignedToACQ173VariantC) && currentStep === Step.LandingPage;
  const {
    isValid
  } = useSignupData(dataKey);
  const onSubmit = evt => {
    if (evt) evt.preventDefault();
    const isReadyToSubmit = isValid && submit || nextButtonEnabled;
    if (isReadyToSubmit) {
      submit();
    }
  };
  if (acq173UpdateEmailInputForm) {
    return /*#__PURE__*/_jsx("form", {
      action: "blue-button-in-all-fields-ios",
      onSubmit: onSubmit,
      children: /*#__PURE__*/_jsxs(Flex, {
        gap: "400",
        inlineSize: "100%",
        children: [/*#__PURE__*/_jsx(View, {
          flexGrow: 1,
          children: /*#__PURE__*/_jsx(SignupDataInput, {
            dataKey: Data.Email,
            formControlMaxInlineSize: "250px",
            height: "",
            inputMode: "email",
            labelOverride: labelOverride,
            shouldShowPlaceholder: true,
            shouldTrimData: true,
            updateInputStyle: acq173UpdateEmailInputForm
          })
        }), /*#__PURE__*/_jsxs(View, {
          marginBlockStart: isAssignedToACQ173VariantC ? '800' : '900',
          children: [/*#__PURE__*/_jsx(Spacer, {
            space: isAssignedToACQ173VariantC ? '50' : '100'
          }), /*#__PURE__*/_jsx(Button, {
            "data-selenium": `${currentStep}_button`,
            disabled: !isValid,
            paddingInline: "700",
            type: "submit",
            use: "primary",
            onClick: onSubmit,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `views.${Step.LandingPage}.nextButtonLabel.verifyEmail`
            })
          })]
        })]
      })
    });
  }
  return /*#__PURE__*/_jsxs("form", {
    action: "blue-button-in-all-fields-ios",
    onSubmit: onSubmit,
    children: [/*#__PURE__*/_jsx(SignupDataInput, {
      customValidationError: customValidationError,
      dataKey: dataKey,
      disabled: disabled,
      height: inputHeight,
      help: help,
      inputMode: inputMode,
      labelOverride: labelOverride,
      ref: ref,
      renderExtraIcons: renderExtraIcons,
      shouldShowPlaceholder: shouldShowPlaceholder,
      shouldTrimData: shouldTrimData,
      type: type
    }), renderExtraContent(), !button ? /*#__PURE__*/_jsx(NextButtonWrapper, Object.assign({
      enabled: nextButtonEnabled,
      onClick: onSubmit
    }, buttonProps)) : button]
  });
});